import ajax from '../utils/ajax'
import * as API from '../config/api'
import { i18n } from '../utils/i18n'
import { getActionPermissions, normalizeFile, infoMap } from '../utils/fileUtils'
import { alert, confirm, toast, ua } from './common'
import store from '../store'

import config from '../config'

const setState = state => {
  Object.assign(store, state)
}

export default {
  handleAction (actionName, data, space) {
    const { typed_id, name, approx_size } = data
    const [type, id] = typed_id && typed_id.split('_')

    switch (actionName) {
      case 'frequent':
        this.addFrequent({
          typed_id
        }).then(res => {
          if (res && res.success) {
            if (['own', 'collab'].includes(type)) {
              config.frequent_space[`has_${type}`] = true
            }

            setState({
              actionState: {
                action: 'frequent',
                type,
                id,
                is_frequently_used: true
              }
            })
          }
        })
        break

      case 'unfrequent':
        this.deleteFrequent({
          typed_id
        }, space === 'frequent').then(res => {
          if (res && res.success) {
            if (['own', 'collab'].includes(type)) {
              config.frequent_space[`has_${type}`] = false
            }

            setState({
              actionState: {
                action: 'frequent',
                type,
                id,
                is_frequently_used: false
              }
            })
          }
        })
        break

      case 'delete':
        // delete data.id
        this.checkLock(data).then(res => {
          if (res) {
            this.deleteFileItem(data).then(res1 => {
              if (res1 && res1.success) {
                data.is_deleted = true
                setState({
                  actionState: {
                    action: 'delete',
                    type,
                    id
                  }
                })
              }
            })
          }
        })
        break

      case 'attribute':
        alert({
          className: 'dialog alert-dialog attribute-dialog',
          title: i18n.t('file.properties'),
          message: `<div class="content">
            <span class="label">${i18n.t('file.name')}${i18n.t('base.colon')}</span><span>${name}</span>
          </div>
          <div class="content">
            <span class="label">${i18n.t('file.size')}${i18n.t('base.colon')}</span><span>${approx_size}</span>
          </div>`,
          confirmButtonText: i18n.t('base.know')
        })
        break

      case 'restore':
      case 'recode-delete':
      case 'permanent-delete':
        this.trashAction(actionName, data).then(res => {
          // delete data.id
          if (res) {
            setState({
              actionState: {
                action: 'delete',
                type,
                id
              }
            })
          }
        })
        break

      default:
        return new Promise(() => {})
    }
  },
  addFrequent (data) {
    return ajax({
      url: API.FREQUENT_ADD,
      data,
      accept_errors: ['external_errors']
    }).then(res => {
      if ((res && res.success) || (res.errors && res.errors.external_errors && res.errors.external_errors[0].error_code === 'duplicate_frequently_used_item_id')) {
        toast.success(i18n.t('file.addFrequent.success'))
        res.success = true
      } else if (res.errors && res.errors.external_errors && res.errors.external_errors[0]) {
        alert(res.errors.external_errors[0].error_tr_msg)
      }
      return res
    })
  },
  deleteFrequent (data, fromFrequent) {
    const ajaxTask = () => {
      return ajax({
        url: API.FREQUENT_DELETE,
        data,
        accept_errors: ['validation_errors']
      }).then(res => {
        if ((res && res.success) || (res.errors && res.errors.validation_errors && res.errors.validation_errors[0].error_code === 'frequently_used_item_not_found')) {
          toast.success(i18n.t('file.removeFrequent.success'))
          res.success = true
        } else if (res.errors && res.errors.validation_errors && res.errors.validation_errors[0]) {
          alert(res.errors.validation_errors[0].error_tr_msg)
        }
        return res
      })
    }

    if (fromFrequent) {
      return confirm({
        className: 'dialog danger-dialog',
        title: i18n.t('file.action.deleteFrequent.confirm'),
        confirmButtonText: i18n.t('file.action.unfrequent'),
        cancelButtonText: i18n.t('base.cancelText')
      }).then(ajaxTask)
    } else {
      return ajaxTask()
    }
  },
  deleteFileItem (item) {
    const { typed_id } = item
    const item_typed_ids = [typed_id]

    return confirm({
      className: 'dialog danger-dialog',
      title: i18n.t('file.deleteConfirm'),
      message: i18n.t('file.moveToTrashAlert', [config.user_info.trash_period]),
      confirmButtonText: i18n.t('base.delete'),
      cancelButtonText: i18n.t('base.cancelText')
    }).then(() => {
      return ajax({
        url: API.DELETE_FILE,
        data: { item_typed_ids },
        loading: i18n.t('base.doing', [i18n.t('base.delete')]),
        successMessage: i18n.t('base.delete.success')
      })
    }).catch(() => {
      // cancel
      return new Promise(() => {})
    })
  },
  handleRename (data) {
    return ajax({
      url: API.EDIT_FILE,
      data
    })
  },
  handleCreate (data) {
    return ajax({
      url: API.NEW_FOLDER,
      loading: i18n.t('base.doing', [i18n.t('file.create')]),
      data
    }).then(response => {
      if (response.success) {
        response.item = response.new_folder
        normalizeFile(response.item)
      }
      return response
    })
  },
  handleMoveCopy (action, data) {
    const APIList = {
      copy: API.COPY_FILE,
      move: API.MOVE_FILE,
      save: API.SAVE_FILE
    }
    if (action === 'save') {
      data.scenario = 'share'
    }
    return ajax({
      url: APIList[action],
      data,
      accept_errors: ['external_errors', 'permission_denied'],
      loading: i18n.t(`file.action.${action}Ing`)
      // successMessage: i18n.t(`file.action.${action}Done`)
    }).then(response => {
      if (response.errors) {
        const errors = response.errors
        alert(errors.permission_denied ? i18n.t('base.noPermission') : errors.external_errors[0].error_tr_msg)
        if (errors.external_errors[0].error_code === 'target_folder_not_deleted') {
          response.error_type = 'target'
        } else if (errors.permission_denied || errors.external_errors[0].error_code === 'item_is_deleted') {
          // 目标文件夹也有可能报 permission_denied，但此处无法区分，都归为操作item错误，取消操作
          response.error_type = 'item'
        }
      } else if (response.success && action === 'copy' && response.files_and_folders) {
        normalizeFile(response.files_and_folders[0])
      }

      if (response.async_copying_items || response.async_moving_items) {
        alert(i18n.t('file.storage.moveCopy', [i18n.t(`file.action.${action}`)]))
      } else if (response.success) {
        toast.success(i18n.t(`file.action.${action}Done`))
      }

      return response
    })
  },
  checkLock (items, actionName) {
    return new Promise((resolve) => {
      let unlocked = true
      const isArray = Array.isArray(items)
      const itemList = isArray ? items : [items]
      if (itemList.length === 1) {
        const url = `${API.FILE_INFO}?item_typed_id=${itemList[0].typed_id}`
        ajax({
          url
        }).then((json) => {
          if (json && json.success) {
            const permissions = getActionPermissions(json.item)
            resolve({
              unlocked: permissions && permissions.includes('perm_action_when_locked'),
              items: [json.item]
            })
            // TODO: updateItem
            // dispatch(itemActions.updateFileItem(json.item))
          }
        })
      } else {
        itemList.forEach(item => {
          unlocked = unlocked && (item.action_permissions && item.action_permissions.includes('perm_action_when_locked'))
        })
        resolve({
          unlocked,
          items: itemList
        })
      }
    }).then(data => {
      const { unlocked, items } = data

      // TODO: 可能要去掉
      // eslint-disable-next-line eqeqeq
      if (items.length === 1 && items[0].locked == 3 && actionName === 'edit-online') {
        return true
      }

      if (!unlocked) {
        const lockUser = items[0].lock_user
        const message = items.length === 1 ? i18n.t('file.actionFailed.fileLocked', [lockUser ? `${lockUser.name}(${lockUser.login})` : '']) : i18n.t('file.actionFailed.multiLocked')

        alert(message)
        return false
      }

      return true
    })
  },
  trashAction (actionName, data) {
    const { typed_id, owned_by: { name, login, id } } = data
    const confirmTitle = messages[actionName]
    const confirmButtonText = infoMap[actionName]
    return confirm({
      className: 'dialog danger-dialog',
      title: confirmTitle,
      confirmButtonText,
      cancelButtonText: i18n.t('base.cancelText')
    }).then(() => {
      return ajax({
        url: actionName === 'restore' ? API.RESTORE_FILE : API.PERMANENT_DELETE_FILE,
        data: {
          item_typed_ids: [typed_id]
        },
        accept_errors: ['validation_errors', 'external_errors']
      }).then(res => {
        if (res && res.success) {
          toast.success(successMessages[actionName])
          return true
        } else if (res.errors) {
          const { validation_errors, external_errors } = res.errors
          let [{ error_tr_msg, error_code }] = validation_errors || external_errors
          if (error_code === 'restore_folder_without_permission') {
            error_tr_msg += `:${name}(${login})`
          }
          if (id !== config.user_info.id && error_code === 'external_item_parent_missing') {
            error_tr_msg += i18n.t('base.period') + i18n.t('file.trash.contactOwner', [name, login])
          }
          alert({
            className: 'dialog',
            title: failMessages[actionName],
            message: error_tr_msg || i18n.t('file.trash.error'),
            confirmButtonText: i18n.t('base.know')
          })
        }
      })
    }).catch(() => {})
  },
  downloadFile (file, extParams = {}) {
    if (ua.qq || ua.wechat) {
      setState({
        actionState: {
          action: 'downloadInWechat'
        }
      })
      return
    }

    const { id, type } = file
    let query = `file_id=${id}&no_redirect=true`
    let url = ''
    if (extParams.unique_name || extParams.shareToken) {
      query += `&unique_name=${extParams.unique_name || extParams.shareToken}`
    }
    if (extParams.password && extParams.scenario === 'share') {
      query += `&password=${extParams.password}`
    }
    if (extParams.version_id) {
      url = `${API.DOWNLOAD_VERSION}?${query}&file_version_id=${extParams.version_id}`
    } else {
      if (extParams.scenario) {
        query += `&scenario=${extParams.scenario}`
      }
      url = `${API.DOWNLOAD_FILE}?${query}`
    }

    if (type === 'folder') {
      const loadingToast = toast({
        message: i18n.t('base.prepareDownload'),
        duration: 0
      })
      ajax({
        url: `${API.PACK_DOWNLOAD}?${query}`,
        methods: 'POST',
        data: {
          item_typed_ids: [`${type}_${id}`]
        }
      }).then(json => {
        loadingToast.clear()
        if (json && json.download_url) {
          this.downloadUrl(json.download_url)
        }
      })
    } else {
      let loadingToast
      let needDownloadCheck = false
      try {
        needDownloadCheck = extParams.scenario === 'share' && config.externalShareResponse.process.share_link.has_watermark_template
      } catch (error) {
        needDownloadCheck = false
      }

      if (needDownloadCheck) {
        loadingToast = toast({
          message: i18n.t('base.prepareDownload'),
          duration: 0
        })
      }
      ajax({
        url
      }).then(json => {
        if (json && json.download_url) {
          this.downloadUrl(json.download_url)
          // 轮询
          const fetchStatus = () => {
            ajax({
              noPrefix: true,
              url: json.download_url.replace('/download/', '/download_check/')
            }).then(res => {
              if (res.isSuccess) {
                if (res.process === 2 || res.process === 3) {
                  loadingToast && loadingToast.clear()
                  setTimeout(() => {
                    if (res.process === 3) {
                      // 下载失败
                      toast({
                        message: i18n.t('base.downloadFail'),
                        duration: 0
                      })
                    }
                  }, 500)
                } else {
                  setTimeout(fetchStatus, 1000)
                }
              } else {
                loadingToast && loadingToast.clear()
              }
            })
              .catch(() => {
                loadingToast && loadingToast.clear()
              })
          }
          if (needDownloadCheck) {
            fetchStatus()
          }
        }
      })
    }
  },
  downloadUrl (url) {
    if (ua.iOS) {
      window.location.assign(url)
    } else {
      const hiddenIFrameID = 'hiddenDownloader'
      let iframe = document.getElementById(hiddenIFrameID)
      if (iframe === null) {
        iframe = document.createElement('iframe')
        iframe.id = hiddenIFrameID
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
      }
      iframe.src = url
    }
  }
}

const messages = {
  'restore': i18n.t('file.action.restore.confirm'),
  'recode-delete': i18n.t('file.action.recodeDelete.confirm'),
  'permanent-delete': i18n.t('file.action.permanentDelete.confirm')
}

const successMessages = {
  'restore': i18n.t('file.action.restore.done'),
  'recode-delete': i18n.t('file.action.recodeDelete.done'),
  'permanent-delete': i18n.t('file.action.permanentDelete.done')
}

const failMessages = {
  'restore': i18n.t('file.action.restore.fail'),
  'recode-delete': '',
  'permanent-delete': ''
}
